import { render, staticRenderFns } from "./editDocumento.vue?vue&type=template&id=2013ee4a"
import script from "./editDocumento.vue?vue&type=script&lang=js"
export * from "./editDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports